import { Component, For } from "solid-js";
import { ListItem } from "../library/types";

type OptionsProps = { list: ListItem[]; }
export const Options : Component<OptionsProps> = (props) => <For each={props.list}>{(item) => <option value={item.Value}>{item.Text}</option>}</For>;